import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = ({ isLoggin }: { isLoggin: boolean }) => {
  return isLoggin ? <Navigate to="/dashboard" replace /> : <Outlet />;
};

export default PublicRoute;
